import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {CurrencyState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class CurrencyQuery extends QueryEntity<CurrencyState> {

  constructor(protected store: Store) {
    super(store);
  }

}
